import * as crudProductSelectors from "./selectors";

import crudProductActions from "./actions";
import reducer from "./redcuer";

const crudProductReducer = reducer;

export { crudProductActions, crudProductReducer, crudProductSelectors };
